export function establishConnection(
    url,
    globalMessages,
    gettext,
    maxRetries = 3,
    initialDelay = 3000
) {
    let eventSource;
    let retryCount = 0;
    let delay = initialDelay;

    const errorMessageConnecting = gettext('De verbinding met de server is verloren, we proberen deze te herstellen. Eventjes geduld.');
    const errorMessageFailed = gettext('Er is iets mis gegaan, onze diensten zijn automatisch verwittigd van dit probleem en zullen het zo snel mogelijk oplossen.');

    function connect() {
        // ensure a new connection is attempted each time
        if (eventSource) {
            eventSource.close();
        }

        eventSource = new EventSource(url);

        eventSource.onerror = function (err) {
            console.error("EventSource failed:", err);
            if (retryCount < maxRetries) {
                globalMessages.value = [errorMessageConnecting];
                retryCount++;
                delay *= 1.5; // increase delay
                setTimeout(connect, delay);
            } else {
                globalMessages.value = [errorMessageFailed];
            }
        };

        // Add this part to handle successful reconnection
        eventSource.onopen = function () {
            retryCount = 0; // Reset retry count
            delay = initialDelay; // Reset delay
            globalMessages.value = []; // Clear error messages
        };
    }

    connect();

    // note: usually calling eventSource.close() in beforeUnMount or onUnMount in the vue component where we use it
    // should do the trick but because of the way we use vue these 2 lifecycle hooks are not being triggered
    window.addEventListener('beforeunload', function () {
        if (eventSource) {
            eventSource.close();
        }
    });

    return eventSource;
}